import React, { lazy, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import 'rc-tooltip/assets/bootstrap.css';
import { useHistory } from 'react-router-dom';

const layout = window?.$environment?.CURRENT_LAYOUT;
const Modal = require(`globalcomponents/UI/Modal/${layout}`).default;
const Button = lazy(() => import(`globalcomponents/UI/Button/${layout}`));
const SubHeader = lazy(() => import(`globalcomponents/SubHeader/${layout}`));
const PercentageBarGraph = lazy(() =>
  import(`globalcomponents/UI/Graph/PercentageBarGraph/${layout}`)
);

const OperatingTerritory = ({
  i18n,
  radiusOverages,
  companyId,
  getVehicles
}) => {
  const [total, setTotal] = useState(0);
  const [res, setModalVehicleName] = useState(null);
  const history = useHistory();

  useEffect(() => {
    if (radiusOverages) {
      setTotal(
        radiusOverages.reduce((sum, ele) => {
          return sum + ele.vehicleCount;
        }, 0)
      );
    }
  }, [radiusOverages]);

  const getPercentage = (count) => {
    return `${(count / total) * 100}%`;
  };

  const openVehicleNamePopupModal = (type, res, req) => {
    setModalVehicleName(res);
  };

  return (
    <div className="grid-item">
      <div className="dailyRadiusHeader">
        <SubHeader
          variant="h1"
          className="statsHeading"
          text={i18n.t('scoreCard.radiusStats')}
        />
        <Button
          type="submit"
          label={i18n.t('Track Vehicle')}
          onClick={(e, d) => {
            history.push(`/vehicle/list`);
          }}
        />
      </div>

      <div className="teritory-details">
        {radiusOverages &&
          radiusOverages.map((item) => {
            return (
              <PercentageBarGraph
                onClick={() => {
                  getVehicles({
                    apiId: 'getVehiclesForRadius',
                    data: {
                      complianceEnum: item.complianceEnum,
                      companyId: companyId
                    },
                    callback: openVehicleNamePopupModal
                  });
                }}
                label={item?.complianceName}
                percentage={getPercentage(item.vehicleCount || 0)}
                count={item.vehicleCount || 0}
              />
            );
          })}
      </div>

      {res && (
        <Modal
          open={true}
          setOpen={setModalVehicleName}
          data={{
            content: () => {
              return (
                <div className="driverNameModal">
                  <div className="headWrapper">
                    {i18n.t('Vehicles of Radius ')} {res?.complianceName}
                  </div>
                  <ul className="scrollContent">
                    {res?.vehicles?.map((items, index) => {
                      return (
                        <li key={index}>
                          <a
                            className="vehicleLink"
                            href={`/vehicle/edit/${items.idPub}`}
                          >
                            {items.name}
                          </a>
                        </li>
                      );
                    })}
                  </ul>
                </div>
              );
            }
          }}
          deletePopup
          withCloseIcon
          alignItemsLeft
          width={'260px'}
        />
      )}
    </div>
  );
};

export default OperatingTerritory;

OperatingTerritory.defaultProps = {};

OperatingTerritory.propTypes = {
  radiusOverages: PropTypes.object.isRequired
};
